import axios from 'axios';
import { getAuthToken } from '../../services/clientConfig';

// Configure your API base URL here
export const API_BASE_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL + '/api'
  : '/api';

/**
 * Create configured axios instance
 */
export const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

/**
 * Request interceptor to add auth token
 */
apiClient.interceptors.request.use(
  (config) => {
    const token = getAuthToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Identify end path for intuitive loading UI label
    let endpointName = 'API';
    if (config.url) {
      endpointName = config.url.split('/').pop().split('?')[0];
    }
    window.dispatchEvent(new CustomEvent('global-loading-start', { detail: { filePath: endpointName } }));
    
    // Attach progress tracking automatically to the Axios request
    config.onDownloadProgress = (progressEvent) => {
      if (progressEvent.total) {
        let percentage = Math.round((progressEvent.loaded * 100) / progressEvent.total);
        window.dispatchEvent(new CustomEvent('global-loading-progress', { detail: { filePath: endpointName, percentage } }));
      }
    };

    return config;
  },
  (error) => {
    let endpointName = error?.config?.url?.split('/').pop().split('?')[0] || 'API';
    window.dispatchEvent(new CustomEvent('global-loading-end', { detail: { filePath: endpointName } }));
    return Promise.reject(error);
  }
);

/**
 * Response interceptor for error handling
 */
apiClient.interceptors.response.use(
  (response) => {
    let endpointName = response.config?.url?.split('/').pop().split('?')[0] || 'API';
    window.dispatchEvent(new CustomEvent('global-loading-end', { detail: { filePath: endpointName } }));
    return response;
  },
  (error) => {
    let endpointName = error?.config?.url?.split('/').pop().split('?')[0] || 'API';
    console.error('API Error:', error);
    window.dispatchEvent(new CustomEvent('global-loading-end', { detail: { filePath: endpointName } }));
    return Promise.reject(error);
  }
);

/**
 * Get authorization headers with token
 */
export const getAuthHeaders = (contentType = 'application/json') => {
  const token = getAuthToken();
  return {
    Authorization: token ? `Bearer ${token}` : undefined,
    'Content-Type': contentType,
  };
};
